<tt-field-group v-bind="{ asFieldset: true, labelId, describedbyId, errorText, hintText, label, required }">
  <div class="tt-c-rating-meter">
    <span v-for="n in 5"
          :ref="setBoxRef"
          role="radio"
          :class="['tt-c-rating-meter__item', { 'tt-c-rating-meter__item--on': rating >= n }]"
          :aria-checked="idsToRatings[modelValue] <= n"
          :aria-describedby="describedbyIdValue"
          :name="labelId"
          :tabindex="idsToRatings[modelValue] === n || (!modelValue && n === 1) ? '0' : '-1'"
          @click="ratingSelected($event, n)"
          @keydown="ratingSelected($event, n)"
          @mouseenter="ratingEnter(n)"
          @mouseleave="ratingLeave()"
          :key="n">
      <span class="tt-u-clip-hide" v-html="$msg('ratingMeter.rating', [n])"></span>
    </span>
  </div>
</tt-field-group>